<div class="controls-container">
    <div class="controls-header">Breadcrumb</div>

    <div class="controls-sub-header">Breadcrumb</div>

    <pm-breadcrumb [Path]="Path" (Click)="OnLinkClick($event)"></pm-breadcrumb>

    <!-- <pm-properties [Item]="BreadcrumbControl"></pm-properties> -->
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/breadcrumb/breadcrumb.html